@if (quickOrder$ | async) {
<form
  #validateQuickOrderForm
  [formGroup]="quickOrderForm"
  (ngSubmit)="onAddProducts()"
  [attr.aria-label]="'quickorder.page.form.label' | translate"
  (keyup)="isInvalidForm()"
  (mousemove)="isInvalidForm()"
>
  <formly-form [model]="model" [fields]="fields" [options]="options" [form]="quickOrderForm" class="pt-1" />
  <button
    type="submit"
    class="btn btn-primary"
    [disabled]="quickOrderForm.pristine || inValidForm"
    data-testing-id="add-form-to-cart"
  >
    {{ 'quickorder.page.add.cart' | translate }}
  </button>
  <!-- <button type="button" class="btn btn-link" (click)="reset()">
    {{ 'quickorder.page.reset.form' | translate }}
  </button> -->
</form>
}
